const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Remove+Credit+Card+from+Profile+API


function removeCreditCardFromProfile(userProfileId, creditCardId) {
    let url = `/api/users/profiles/${userProfileId}/creditCard/${creditCardId}`;
    return ufeApi.makeRequest(url, { method: 'DELETE' }).
        then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = removeCreditCardFromProfile;
